/** Mirror of the server default: bare → .US, else honor the explicit exchange. */
export function normalizeSymbol(input: string): string {
  const s = input.trim().toUpperCase()
  if (!s) return s
  if (s.includes('.')) return s
  return `${s}.US`
}

/** Friendly display: drop the .US suffix, keep other exchanges. */
export function displaySymbol(symbol: string): string {
  return symbol.replace(/\.US$/, '')
}
